export default [
  // {// 第三方登陆
  //   path: '/thirdLogin',
  //   // name: 'orgVerification',
  //   component: () => import('@/components/glyunVue2/index.vue'),
  //   meta: {
  //     title: 'v2_global_solid_cloud'
  //   }
  // },
  {//组织验证
    path: '/orgVerification',
    // name: 'orgVerification',
    component: () => import('@/components/glyunVue2/index.vue'),
    meta: {
      title: 'v2_router_label11',
    }
  },
  {//注册
    path: '/registered',
    // name: 'registered',
    component: () => import('@/components/glyunVue2/index.vue'),
    meta: {
      title: 'v2_register'
    }
  },
  {//找回密码
    path: '/retrieve_password',
    // name: 'retrieve_password',
    component: () => import('@/components/glyunVue2/index.vue'),
    meta: {
      title: 'v2_homepage_zhaohuimima'
    }
  },
  // {//找回密码
  //   path: '/modify_password',
  //   // name: '/modify_password',
  //   component: () => import('@/components/glyunVue2/index.vue'),
  //   // meta: {
  //   //   title: 'v2_homepage_zhaohuimima'
  //   // }
  // },
  {//平台切换公告
    path: '/platformSwitchAnnouncement',
    // name: 'retrieve_password',
    component: () => import('@/components/glyunVue2/index.vue'),
  },

  {//内部账号登录验证
    path: '/login_authentication',
    component: () => import('@/components/glyunVue2/index.vue'),
    // meta: {
    //   title: '内部账号校验'
    // }
  },
  {//无权限页面
    path: '/mailVerification',
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {//无权限页面
    path: '/blankPage',
    component: () => import('../views/nav/index.vue'),
    children: [
      {
        path: '/blankPage',
        component: () => import('@/components/glyunVue2/index.vue'),
      }
    ]
  },
  //概览
  {
    path: '/station',
    // name: 'station',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//电站概览
        path: '',//使用相对路径
        name: 'station/',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_plant_overview',
          // routeAuthCode: 'A0100',
        }
      },
      {//电站概览
        path: '/station2',
        name: 'station2',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_plant_overview',
          // routeAuthCode: 'A0100',
        }
      },
      {//刷新首页跳转空白页返回
        path: '/station/middlePage',
        name: 'middlePage',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_menu_survey'
        }
      },
      {
        path: '/station/addstation',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_addplant'
        }
      },
      {
        path: '/station/addstation/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_introduction_label2'
        }
      },
      {//设备概览
        path: '/station/device',
        name: 'device',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_overview',
          routeAuthCode: 'A0101'
        }
      },
      {
        path: '/station/stationdetail_1',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_router_label14'
        }
      },
      {//新版电站详情
        path: '/station/stationDetails/generalSituation/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_details_overview'
        }
      },
      {//电站详情->设备->设备删除记录
        path: '/station/stationDetails/device/deviceDeleteRecords/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_details',
        }
      },
      {//电站详情->设备->设备删除记录->删除的设备快照详情
        path: '/station/stationDetails/device/deviceDetails/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_label7'
        }
      },
      {
        path: '/station/plantView',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_layout_layout'
        }
      },
      {
        path: '/station/plantView/componentDetails',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_customModule_CustomModule'
        }
      },
      {
        path: '/station/plantView/optimizerDetails',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_layout_optimiser_access'
        }
      },
      {
        path: '/station/plantView/optimizerWarningDetails',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_layout_optimizer_alarms'
        }
      },
      {
        path: '/station/graphView',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_router_label14'
        }
      },
      {
        path: '/station/plantMaterial/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_introduction_label1'
        }
      },
      {
        path: '/station/stationdetail_5',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_alarm'
        }
      },
      {
        path: '/station/correctRecord',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_details'
        }
      },
      {
        path: '/station/equipmentAbnormalOffline',
        name: 'stationEquipmentAbnormalOffline',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_device_abnormal_offline',
        }
      },
      {
        path: '/station/lowEfficiencyStation',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_inefficient_generation_warnings',
        }
      },
      {
        path: '/station/earlywarningPage/:warningType',// 组串预警
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_string_abnormal_warning',
        }
      },
      {
        path: '/station/devicedetail',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_upgrade_record_device'
        }
      },
      {//逆变器详情
        path: '/station/inverter/inverterdetail',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_label7'
        }
      },
      {//升级记录
        path: '/station/inverter/inverterdetail/upgradesLog/:deviceType/:id/:sn',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_datalogger_details_upgrade_record'
        }
      },
      {//逆变器秒级数据
        path: '/station/inverter/inverterdetail/secondData/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_real_time_data'
        }
      },
      {
        //逆变器自定义参数创建任务 秒级数据
        path: "/station/inverter/inverterdetail/task/:id",
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_inverter_details_custom_parameters",
        },
      },
      {//逆变器事件记录
        path: '/station/inverter/inverterdetail/eventRecord/:sn',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_event_records'
        }
      },
      {//逆变器录波记录
        path: '/station/inverter/inverterdetail/waveRecord/:sn',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: '录波记录'
        }
      },
      {//逆变器录波记录
        path: '/station/deviceDetail/waveRecord/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: '录波记录'
        }
      },
      {//设备事件记录
        path: '/station/deviceDetail/eventRecord/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_event_records'
        }
      },
      { //逆变器报警信息
        path: '/station/inverter/inverterdetail/police_inverter/:sn',
        name: 'police_inverter',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_inverter_alarm_messages'
        }
      },
      { //逆变器历史故障
        path: '/station/inverter/inverterdetail/historyFaults/:sn',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_history_faults'
        }
      },
      { //逆变器历史告警
        path: '/station/inverter/inverterdetail/historyWarning/:sn',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_history_alarms'
        }
      },
      {
        path: '/station/device/deviceAlarm/:deviceType/:sn',// 充电桩是sn,
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_charger_charger_alarm_message'
        }
      },
      {
        path: '/station/device/epmAlarm/:deviceType/:sn',// EPM报警信息
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title:'v2_epm_alarm_info'
        }
      },
      {//逆变器详情远程控制-储能逆变器v3.2新增
        path: "/station/inverter/inverterdetail/storageInverterRemoteControl",
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_inverter_control'
        }
      },
      {//逆变器远程控制-子级界面-储能逆变器v3.2新增
        path: "/station/inverter/inverterdetail/controlComponent",
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_inverter_control'
        }
      },
      {//逆变器远程控制-子级界面-控制记录V3.4.2新增
        path: "/station/inverter/inverterdetail/controlRecord/:id",
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_control_records'
        }
      },
      {//逆变器远程控制-子级界面-控制记录V3.4.2新增
        path: "/station/inverter/inverterdetail/operationRecord/:id",
        component: () => import('@/components/glyunVue2/index.vue'),
      },
      /**
       * 新逆变器控制
       * */
      {//逆变器远程控制V4.1.1
        path: "/station/inverter/inverterdetail/remoteControl/:id",
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_inverter_control'
        }
      },


      {//采集器详情
        path: '/station/collector/collectordetail',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_datalogger_details_datalogger_details'
        }
      },
      {//采集器升级记录
        path: '/station/collector/upgradeRecord/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_datalogger_details_upgrade_record'
        }
      },
      {//采集器控制
        path: '/station/collector/collectorControl',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_datalogger_DataloggerControl',

        }
      },
      {//防逆流控制
        path: '/station/collector/antiReverseControl',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_anti_back_flow_control',

        }
      },
      {//EPM详情
        path: '/station/epm/epmdetail/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_router_label32'
        }
      },
      //epm远程控制
      {
        path: "/station/epm/epmRemoteControl",
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_epm_details_epm_control'
        }
      },
      {//EPM新版远程控制
        path: '/station/epm/epmdetail/remoteControl/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_epm_details_epm_control'
        }
      },
      {//气象仪详情
        path: '/station/weather/weatherDetail/:sn',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_meteorograph_meteorographDetails'
        }
      },
      {//电表详情
        path: '/station/electricMeter/electricMeterDetail/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_meter_meterDetails'
        }
      },
      {//充电桩详情
        path: 'charge/chargerDetail/:sn',
        // component: () => import('@/components/glyunVue2/index.vue'),
        component: () => import('@/views/overview/device/details/charge/deviceInfo.vue'),
        meta: {
          title: "v2_charger_charger_details"
        }
      },
      {//充电桩充电记录
        path: 'charge/chargerRecord/:chargerSn',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_charger_charging_records"
        }
      },
      {//充电桩卡片管理
        path: 'charge/chargCardManage/:sn',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_charger_card_management"
        }
      },
    ]
  },

  //运维
  {
    path: '/operationManage',
    // name: 'police',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//报警信息
        path: '/police',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_alarm_information',
          routeAuthCode: 'A0200',
        }
      },
      //预警信息
      {//设备异常离线
        path: '/defensePolice/equipmentAbnormalOffline',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_device_abnormal_offline',
          routeAuthCode: 'A020404',
        }
      },
      {//低效发电电站
        path: '/defensePolice/lowEfficiencyStation',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_inefficient_power_plants',
          routeAuthCode: 'A020405'
        }
      },
      {//组串发电预警
        path: '/defensePolice/earlywarningPage/:warningType',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_string_abnormal_warning',
          routeAuthCode: 'A020406'
        }
      },
      {//预警详情
        path: '/defensePolice/detail',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_warning_details'
        }
      },
      {//报警详情（V3.4.1修改）
        path: '/police/detail',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_om_alarm_alarm_details'
        }
      },
      {
        path: '/operationManage/IVCurve',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_iv_curve_iv_curve_diagnosis',
          routeAuthCode: 'A0201'
        }
      },
      {
        path: '/operationManage/IVCurveDetails/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_iv_curve_iv_curve_diagnostic_details'
        }
      },
      {//离散率分析
        path: '/dispersion_ratio',
        // name: 'police',
        component: () => import('../views/nav/index.vue'),
        children: [
          {
            path: '',
            component: () => import('@/components/glyunVue2/index.vue'),
            meta: {
              title: 'v2_router_label26',
              routeAuthCode: 'A0203',
            }
          },
        ]
      }
    ]
  },

  //报表
  {
    path: '/report_station',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//电站报表
        path: '/report_station',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_details_plant_report',
          routeAuthCode: 'A0300',
        }
      },
      {//电量报表
        path: '/report_electric',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_report_energy_report',
          routeAuthCode: 'A0301',
        }
      },
      {//设备报表
        path: '/report_equipment',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_report_inverter_report',
          routeAuthCode: 'A0302',
        }
      },
      {//自定义报表
        path: '/report_custom',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_report_custom_report_custom_report',
          routeAuthCode: 'A0303',
        }
      },
      {// 订阅报表
        path: '/reportSubscription',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_report_report_subscription_report_subscription',
          routeAuthCode: 'A0306',
        }
      },
      {//导出记录
        path: '/exportRecords',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_export_record',
          routeAuthCode: 'A0305',
        }
      }
    ]
  },

  //发现
  {
    path: '/notice',
    component: () => import('../views/nav/index.vue'),
    children: [
      {
        path: '/notice',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_discover',
          routeAuthCode: 'A0511',
        }
      },
      {
        path: '/notice/notice_detail',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_notice_articleDetails'
        }
      }
    ]
  },

  //服务
  {
    path: '/management/stationManagement',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//电站管理
        path: '/management/stationManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_plantmanage_plant_management',
          routeAuthCode: 'A0501',
        }
      },
      {// 固件列表外（电池厂商）
        path: '/management/bms/firmwareList/:inOut',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_battery_firmware',
          routeAuthCode: 'A0514',
        }
      },
      {//BMS固件详情
        path: '/management/bms/firmwareList/firmwareDetail/:id/:inOut',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_ota_firmware_details'
        }
      },
      {//设备管理
        path: '/management/equipment',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_device_device_management',
          routeAuthCode: 'A0502',
        }
      },
      {//组织管理
        path: '/management/orgStructure',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_organization_management',
          routeAuthCode: 'A0503',
        }
      },
      // {//质保查询
      //   path: '/serve/warrantyQuery',
      //   component: () => import('@/components/glyunVue2/index.vue'),
      //   meta: {
      //     title: 'v2_service_extend_warranty_warranty_enquiry',
      //     routeAuthCode: 'A0504',
      //   }
      // },
      {
        //质保下载文件扫码
        path: '/serve/warrantyFiles/:sn',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_menu_label3'
        }
      },
      {//质保申诉记录
        path: '/serve/quality_record',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_warrantyAppeal_WarrantyAppealRecord'
        }
      },
      {//绑定SIM卡
        path: '/relevanceSIM',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_router_label31',
          routeAuthCode: 'A051802'
        }
      },
      {//第三方授权管理
        path: '/OAuth',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_thirdparty_auth_management',
        }
      },
      {//授权详情
        path: '/OAuthDetail',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_auth_details',
        }
      },
      {//调用日志
        path: '/callLog',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_call_log',
        }
      },
      {//调用日志
        path: '/OAuthOpreateLog',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_call_log',
        }
      },
      {// 产品资料
        path: '/productInformation',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_product_info',
          routeAuthCode: 'A051901'
        }
      },
      {// 质保查询
        path: '/serve/extendedWarrantyQuery',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_extend_warranty_warranty_enquiry',
          routeAuthCode: 'A051801'
        }
      },
      {// 延保订单
        path: '/serve/extendedWarrantyOrders',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_extend_warranty_warranty_enquiry',
          routeAuthCode: 'A051701'
        }
      },
      // { //创建订单
      //   path: '/serve/createExtendedWarrantyOrder',
      //   component: () => import('@/components/glyunVue2/index.vue'),
      //   meta: {
      //     title: 'v2_service_extend_warranty_warranty_enquiry'
      //   }
      // },
      { //订单支付结果
        path: '/serve/extendedWarrantyOrderPayResult/:orderId',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_extend_warranty_warranty_enquiry'
        }
      },
      { //订单详情
        path: '/serve/extendedWarrantyOrderDetail/:orderId',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_extend_warranty_warranty_enquiry'
        }
      },
      { //DNSP注册
        path: '/registerDNSP',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_dnsp_register',
          routeAuthCode: 'A051804',
        },
      },
    ]
  },
  // 官网-在线延保
  { //质保查询
    path: '/serve/extendedWarrantyQueryNoLogin',
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  // { //创建订单
  //   path: '/serve/createExtendedWarrantyOrderNoLogin',
  //   component: () => import('@/components/glyunVue2/index.vue'),
  // },
  { //订单支付结果
    path: '/serve/extendedWarrantyOrderPayResultNoLogin/:orderId',
    component: () => import('@/components/glyunVue2/index.vue'),
    meta: {
      title: 'v2_service_extend_warranty_warranty_enquiry'
    }
  },
  { //订单详情
    path: '/serve/extendedWarrantyOrderDetailNoLogin/:orderId',
    component: () => import('@/components/glyunVue2/index.vue'),
    meta: {
      title: 'v2_service_extend_warranty_warranty_enquiry'
    }
  },
  //运营
  {
    path: '/operation',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//Nomination查询
        path: '/operation/nomimationQuery',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_third_party_nomination_enquiry',
          routeAuthCode: 'A0611'
        }
      },
      //账号管理
      {//组织管理
        path: '/operation/installerManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_organization_management',
          routeAuthCode: 'A060000'
        }
      },
      {//安装商授权
        path: '/operation/installerAuthorization',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_account_management_installer_authorisation',
          routeAuthCode: 'A061000'
        }
      },
      {//安装商授权
        path: '/operation/installerAuthorization/orgManagement/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_account_management_account_management'
        }
      },
      {//安装审核
        path: '/operation/installerReview',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_third_party_install_audit',
          routeAuthCode: 'A061001'
        }
      },
      {//安装审核订单详情
        path: '/operation/installerReview/orderDetail/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_extended_warranty_order_details'
        }
      },
      {//安装审核记录
        path: '/operation/installerReview/reviewRecords',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_third_party_records'
        }
      },
      {//业主管理
        path: '/operation/ownerManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_account_management_owner_management',
          routeAuthCode: 'A060001'
        }
      },
      {//内部账号
        path: '/operation/internalAccount',
        name: 'AccountManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_account_management_internal_account',
          keepAlive: true,
          routeAuthCode: 'A060002',
        }
      },
      {//功能权限
        path: '/accountManagement/check_pers',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_account_management_function_authority'
        }
      },
      {//数据权限
        path: '/accountManagement/check_data',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_account_management_data_authority'
        }
      },
      {//其他账号
        path: '/operation/otherAccount',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_menu_label4',
        }
      },
      {//角色管理
        path: '/operation/roleManagement',
        name: 'roleManage',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_account_management_role_management',
          routeAuthCode: 'A060003'
        }
      },
      {//添加角色
        path: '/roleManagement/role_add',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_account_management_role_management',
        }
      },
      {//权限管理
        path: '/operation/authorityManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_account_management_access_management',
          routeAuthCode: 'A060003'
        }
      },
      //设备管理
      {//逆变器管理
        path: '/operation/inverterInformationManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_management_inverter_management',
          routeAuthCode: 'A060100'
        }
      },
      {//采集器管理
        path: '/operation/collectorInformationManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_management_datalogger_management',
          routeAuthCode: 'A060101'
        }
      },
      {//SIM卡信息
        path: '/operation/SIMInformationManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_sim_card',
          routeAuthCode: 'A060102'
        }
      },
      {//延保管理
        path: '/warrantyManagement/extendedWarranty',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_extended_warranty_management',
          routeAuthCode: 'A060702'
          // keepAlive: true
        }
      },
      {//审核延保单
        path: '/warrantyManagement/addExtendedWarranty/:id/:type',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_warranty_management_extended_warranty'
        }
      },
      {//延保审核
        path: '/warrantyManagement/extendedWarrantyReview',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_extended_warranty_review',
          routeAuthCode: 'A060703'
        }
      },
      {//申诉管理
        path: '/warrantyManagement/appealManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_appeal_management',
          routeAuthCode: 'A060704'
        }
      },
      {//换机登记
        path: '/warrantyManagement/changeMachine',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_change_registration',
          routeAuthCode: 'A060705'
        }
      },
      {// 新建换机登记
        path: '/warrantyManagement/addChangeMachine/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_management_new_registration'
        }
      },
      {// 充电桩管理
        path: '/operation/chargeManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_management_charger_management',
          routeAuthCode: 'A060103'
        }
      },
      {//质保检测
        path: '/warrantyManagement/warrantyDetect',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_warranty_management_warranty_test',
          routeAuthCode: 'A060701'
        }
      },
      {//SIM卡账期核对
        path: '/operation/SIMCardAccountPeriodCheck',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_management_sim_period_reconciliation',
          routeAuthCode: 'A060105'
        }
      },
      {//显示屏管理
        path: '/operation/screenInformationManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_management_screen_management',
          routeAuthCode: 'A060104'
        }
      },
      //维护管理
      {//逆变器Model维护
        path: '/maintenanceManagement/inverterModel',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_inverter_model_maintenance',
          routeAuthCode: 'A060200'
        }
      },
      {//故障代码维护
        path: '/maintenanceManagement/alarmCode',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_alarm_code_maintenance',
          routeAuthCode: 'A060201'
        }
      },
      {//国家标准维护
        path: '/maintenanceManagement/nationalStandard',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_national_standard_maintenance',
          routeAuthCode: 'A060202'
        }
      },
      {//国家标准维护(旧)
        path: '/maintenanceManagement/nationalStandardOld',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_national_standard_maintenance_old',
          routeAuthCode: 'A060202'
        }
      },
      {//系列维护
        path: '/maintenanceManagement/series',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_series_maintenance',
          routeAuthCode: 'A060203'
        }
      },
      {//电池维护
        path: '/maintenanceManagement/batterys',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_maintenance_BatteryMaintenance',
          routeAuthCode: 'A060206'
        }
      },
      {//SIM定价
        path: '/productManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_maintenance_management_sim_pricing',
          routeAuthCode: 'A060204'
        }
      },
      {//组件维护
        path: '/componentManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_module_maintenance',
          routeAuthCode: 'A060205'
        }
      },
      {//采集器固件烧录
        path: '/collectorFirmwareBurn',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_maintenance_management_datalogger_firmware_burning',
          routeAuthCode: 'A060207'
        }
      },
      {//充电桩Model维护
        path: '/maintenanceManagement/chargerModel',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_charger_charger_model_maintenance',
          routeAuthCode: 'A060209'
        }
      },
      // {//采集器Model维护
      //   path: '/maintenanceManagement/collectorModel',
      //   component: () => import('@/components/glyunVue2/index.vue'),
      //   meta: {
      //     title: 'v2_maintenance_management_datalogger_model_maintenance',
      //     routeAuthCode: 'A060208'
      //   }
      // },
      //生成管理
      {//老化测试
        path: '/operation/aging',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_menu_nowAging',
          routeAuthCode: 'A060300'
        }
      },
      //订单管理
      {//SIM卡订单
        path: '/orderManagement/flowRecharge',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_management_sim_card_orders',
          routeAuthCode: 'A060400'
        }
      },
      {//SIM卡订单详情
					path: '/orderManagement/flowRecharge/detail/:id',
					component: () => import('@/components/glyunVue2/index.vue'),
					meta: {
						title: 'v2_early_warning_details',
						// routeAuthCode: 'A060400'
					}
				},
      {//流量充值管理
        path: '/orderManagement/trafficRecharge',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_order_management_traffic_recharge_management',
          routeAuthCode: 'A060401'
        }
      },
      {//流量充值审核
        path: '/orderManagement/trafficRechargeReview',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_order_management_traffic_recharge_audit',
          routeAuthCode: 'A060402'
        }
      },
      {//添加流量充值单
        path: '/orderManagement/addTrafficRecharge/:id/:type',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_order_management_traffic_recharge_order'
        }
      },
      {//采集器订单
        path: '/orderManagement/collectorOrders',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_order_management_datalogger_orders',
          routeAuthCode: 'A060403'
        }
      },
      {//采集器订单详情
        path: '/orderManagement/collectorOrderDetail/:orderId',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_details'
        }
      },
      {//采集器发货记录
        path: '/orderManagement/collectorShipmentRecords',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_order_management_datalogger_shipment_records',
          routeAuthCode: 'A060404'
        }
      },
      {//采集器换购记录
        path: '/orderManagement/collectorReplaceRecords',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_order_management_gprs_datalogger_exchange_records',
          routeAuthCode: 'A060405'
        }
      },
      //日志管理
      {//启动日志
        path: '/logManagement/bootLog',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_log_management_startup_log',
          routeAuthCode: 'A060502'
        }
      },
      {//操作日志
        path: '/logManagement/managementOperationLog',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_details_operation_log',
          routeAuthCode: 'A060503'
        }
      },
      {//异常数据
        path: '/logManagement/exception',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_log_management_abnormal_data',
          routeAuthCode: 'A060504'
        }
      },
      {//迁移记录
        path: '/logManagement/migrationRecord',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_log_management_migration_record',
          routeAuthCode: 'A060505'
        }
      },
      //系统管理
      {//文章管理
        path: '/systemManagement/noticeadmin',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_system_management_article_management',
          routeAuthCode: 'A060602'
        }
      },
      {//新增文章
        path: '/noticeadmin/notice_add',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_system_management_add_article',
        }
      },
      {//修改文章
        path: '/noticeadmin/notice_editor',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_system_management_edit_article',
        }
      },
      {//消息通知设置
        path: '/system/noticeConfig',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_system_management_message_notification',
          routeAuthCode: 'A060601'
        }
      },
      {//图片管理
        path: '/systemManagement/imagesManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_system_management_picture_management',
          routeAuthCode: 'A060603'
        }
      },
      {//应用管理
        path: '/systemManagement/applicationManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_system_management_application_management',
          routeAuthCode: 'A060604'
        }
      },
      {//系统配置
        path: '/systemManagement/systemConfig',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_system_management_system_configuration',
          routeAuthCode: 'A060605'
        }
      },
      // 消息管理
      {//公告消息
        path: '/messageManagement/announcement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_message_management_bulletin_message',
          routeAuthCode: 'A060801'
        }
      },
      {//自定义消息
        path: '/messageManagement/customize',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_message_management_custom_messages',
          routeAuthCode: 'A060802'
        }
      },
      {//业务消息
        path: '/messageManagement/business',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_message_management_business_message',
          routeAuthCode: 'A060803'
        }
      },
      {//消息详情
        path: '/messageManagement/messageDetail',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_message_management_message_details'
        }
      },
      // 产品延保
      {//延保订单
        path: '/productExtendedWarranty/extendedWarrantyOrders',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_extended_warranty_extended_warranty_order',
          routeAuthCode: 'A060902'
        }
      },
      {//延保订单详情
        path: '/productExtendedWarranty/orderDetail/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_details'
        }
      },
      {//退款申请
        path: '/productExtendedWarranty/refundRequest',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_extended_warranty_refund_requests',
          routeAuthCode: 'A060903'
        }
      },
      {//退款记录
        path: '/productExtendedWarranty/refundRecords',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_extended_warranty_refund_records',
          routeAuthCode: 'A060904'
        }
      },
      {//延保记录
        path: '/productExtendedWarranty/extendedWarrantyRecords',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_extended_warranty_extended_warranty_records',
          routeAuthCode: 'A060905'
        }
      },
      {//产品目录
        path: '/productExtendedWarranty/productCatalog',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_extended_warranty_product_catalog',
          routeAuthCode: 'A060901'
        }
      },
    ]
  },
  {
    path: '/intelligenceOperation',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//设备分析逆变器
        path: 'deviceAnalysis/inverter',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_inverter',
          routeAuthCode: 'A070000',
        }
      },
      {//设备分析采集器
        path: 'deviceAnalysis/collector',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_datalogger',
          routeAuthCode: 'A070001',
        }
      },
      {//设备分析诊断记录
        path: 'deviceAnalysis/diagnosticRecords',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_analysis_diagnostic_records',
          routeAuthCode: 'A070002',
        }
      },
      {//设备控制 - 逆变器
        path: '/deviceControlManagement/inverter/DeviceControl',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_analysis_inverter_batch_control',
          routeAuthCode: 'A070100',
        }
      },
      {//新增控制 - 逆变器
        path: '/deviceControlManagement/inverter/AddControl',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_control_add_control'
        }
      },
      {//控制详情 - 逆变器
        path: '/deviceControlManagement/inverter/ControlDetail',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_control_control_details'
        }
      },
      {//设备控制 - 采集器
        path: '/deviceControlManagement/collector/DeviceControl',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_analysis_datalogger_batch_control',
          routeAuthCode: 'A070101',
        }
      },
      {//新增控制 - 采集器
        path: '/deviceControlManagement/collector/AddControl',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_control_add_control'
        }
      },
      {//控制详情 - 采集器
        path: '/deviceControlManagement/collector/ControlDetail',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_control_control_details'
        }
      },
      {// nmi批量控制列表
        path: '/deviceControlManagement/nmi/list',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_control_inverter_batch_control_nmi',
          routeAuthCode: 'A070102',
        }
      },
      {// nmi批量控制列表 - 指令详情
        path: '/deviceControlManagement/nmi/details/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_control_command_details'
        }
      },
      // 智能预警
      {//数据看板
        path: '/intelligenceOperation/intelligentEarlyWarning/dataBoard',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_abnormal_warning_data_board',
          routeAuthCode: 'A070602',
        }
      },
      {//我的关注
        path: 'intelligentEarlyWarning/myAttention',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_smart_warning_my_concerns',
          routeAuthCode: 'A070600',
        }
      },
      {//故障预警
        path: 'intelligentEarlyWarning/faultWarning',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_fault_warning',
          routeAuthCode: 'A070601',
        }
      },
      {//我的事件详情实时
        path: 'intelligentEarlyWarning/eventDetailRealTime',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_details'
        }
      },
      {//我的事件详情历史
        path: 'intelligentEarlyWarning/eventDetailHistory',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_details'
        }
      },
      // 设备异常预警
      {//控制详情
        path: '/intelligenceOperation/equipmentAbnormalWarning',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_abnormal_warning',
          routeAuthCode: 'A0704',
        }
      },
      {//控制详情
        path: '/intelligenceOperation/warningConfiguration',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_abnormal_warning_warning_event_configuration',
        }
      },
      //设备升级
      {//采集器固件
        path: '/intelligenceOperation/collectorUpgrade/:inOut',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_datalogger_firmware',
          routeAuthCode: 'A070208,A070200'
        }
      },
      {//采集器版本分布
        path: '/collectorUpgrade/collectorFirmware',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_datalogger_version',
          routeAuthCode: 'A070201',
        }
      },
      {//采集器固件详情
        path: '/collectorUpgrade/collectorUpgradeDetail/:id/:inOut',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_ota_firmware_details'
        }
      },
      {//采集器升级记录
        path: '/collectorUpgrade/collectorUpgradeRecord',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_datalogger_upgrade_records',
          routeAuthCode: 'A070202',
        }
      },
      {//逆变器固件
        path: '/intelligenceOperation/inverterUpgrade/:inOut',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_inverter_firmware',
          routeAuthCode: 'A070207,A070203',
        }
      },
      {//逆变器固件(蓝牙)
        path: '/ota/inverterUpgradeBluetooth',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_ota_local_firmware_start_stop_management'
        }
      },
      {//逆变器固件(蓝牙)详情
        path: '/ota/inverterUpgradeBluetoothDetails/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_ota_firmware_details'
        }
      },
      {//逆变器版本分布
        path: '/inverterUpgrade/inverterFirmware',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_inverter_version',
          routeAuthCode: 'A070204',
        }
      },
      {//逆变器固件详情
        path: '/inverterUpgrade/inverterUpgradeDetail/:id/:inOut',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_ota_firmware_details'
        }
      },
      {//逆变器批次详情
        path: '/inverterUpgrade/batchDetails/:batchId/:deviceType',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_batch_detail'
        }
      },
      {//逆变器升级记录
        path: '/inverterUpgrade/inverterUpgradeRecord',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_inverter_upgrade_records',
          routeAuthCode: 'A070205',
        }
      },

      {//EPM固件
        path: '/intelligenceOperation/epmUpgrade/:inOut',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_epm_firmware',
          routeAuthCode: 'A070210,A070209',
        }
      },
      {//EPM版本分布
        path: '/epmUpgrade/epmFirmware',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_epm_version',
          routeAuthCode: 'A070211',
        }
      },
      {//EPM固件详情
        path: '/epmUpgrade/epmUpgradeDetail/:id/:inOut',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_ota_firmware_details'
        }
      },
      {//EPM升级记录
        path: '/epmUpgrade/epmUpgradeRecord',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_epm_upgrade_records',
          routeAuthCode: 'A070212',
        }
      },

      {//BMS固件列表
        path: '/intelligenceOperation/bms/firmwareList/:inOut',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_bms_firmware',
          routeAuthCode: 'A070215,A070214',
        }
      },
      {//BMS固件详情
        path: '/intelligenceOperation/bms/firmwareList/firmwareDetail/:id/:inOut',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_ota_firmware_details'
        }
      },
      {//逆变器升级测试
        path: '/intelligenceOperation/upgradingTest',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_equipment_upgrade_pressure_upgrade',
          routeAuthCode: 'A070206',
        }
      },
      {//满发小时数
        path: '/intelligenceOperation/powerAnalysis/fullHours',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_details_full_load_hours',
          routeAuthCode: 'A070300',
        }
      },
      {//采集器信号
        path: '/intelligenceOperation/insight/collectorSignal',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_export_record_datalogger_signal',
          routeAuthCode: 'A070301',
        }
      },
      {//任务管理
        path: 'taskManage',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_task_management_ota_upgrade',
          routeAuthCode: 'A070500',
        }
      },
      {//任务管理详情
        path: 'taskDetails/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_early_warning_details',
        }
      }
    ]
  },
  //其他
  {
    path: '/qingdingbao',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//晴顶宝
        path: '/qingdingbao',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: '晴顶宝'
        }
      },
      //开卡管理
      {//开卡名单管理
        path: '/management/openCardManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_card_opening_list_management',
          routeAuthCode: 'A0800'
        }
      },
      {//项目公司管理
        path: '/management/projectCompanyManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_project_company_management',
          routeAuthCode: 'A0801',
        }
      },
      {//录入员账号管理
        path: '/management/reporterManagement',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_recorder_account_management',
          routeAuthCode: 'A0802',
        }
      },
      //NMI控制
      {//NMI控制列表
        path: '/other/NMIControl',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_sapn_NmiControl',
          routeAuthCode: 'A0803',
        }
      },
      {//新增NMI控制
        path: '/other/addNMIControl',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_control_add_control'
        }
      },
      {//NMI控制详情
        path: '/other/checkNMIControl',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_control_control_details'
        }
      },
    ]
  },

  //帮助
  {
    path: '/help',
    component: () => import('../views/nav/index.vue'),
    children: [
      {
        path: '/help',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_details_faq'
        }
      },
      {
        path: '/help/helpDetails',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_menu_help'
        }
      },
      {
        path: '/help/help_use',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_help'
        }
      },
      {//帮助_产品资料
        path: '/helpPDF',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_service_product_info'
        }
      }
    ]
  },

  //我的
  {
    path: '/set',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//基本设置
        path: '/set',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_basic_settings',
        }
      },
      {//我的资料
        path: '/my',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_my_info',
        }
      },
      {//修改密码
        path: '/passwordChange',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_chang_password'
        }
      },
      {//api管理
        path: '/apiManage',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_apiManage_ApiManagement',
          routeAuthCode: 'A0507',
        }
      },
      {//SDK接入
        path: '/sdkManage',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_SDKAccess_SDKAccess',
          routeAuthCode: 'A0512',
        }
      }
    ]
  },
  //消息
  {
    path: '/messageCentre',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//系统通知
        path: 'systemInfo',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_message_system_notification'
        },
      },
      {//待办提醒
        path: 'receiptInfo',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_message_todo'
        }
      },
      {//待办提醒
        // messageType 0:系统通知,1:待办提醒
        path: 'messageDetails/:messageType/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_message_management_message_details'
        }
      }
    ]
  },
  //收藏夹
  {
    path: '/favorites',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//收藏夹列表
        name: 'favorites/favoritesList',
        path: 'favoritesList',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_my_favorites'
        }
      },
      {//收藏夹详情
        name: 'favorites/favoritesDetails',
        path: 'favoritesDetails/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_plant_my_favorites'
        }
      },
    ]
  },
  // 操作日志
  {
    path: '/operationLog',
    component: () => import('../views/nav/index.vue'),
    children: [
      {//设备详情跳转-操作日志
        name: 'operationLog',
        path: '',
        //子应用-设备详情
        component: () => import('@/components/glyunVue2/index.vue'),
        //component: () => import('../views/operation/operationLog/index.vue'),
        meta: {
          title: 'v2_plant_details_operation_log'
        }
      },
    ]
  },
  //大屏
  {
    path: "/PlantsDataV2021",
    // name: "大屏展示2021",
    component: () => import('@/components/glyunVue2/index.vue'),
    meta: {
      title: 'v2_router_label23'
    }
  },
  {
    path: "/PlantDataV2021",
    // name: "大屏展示电站详情2021",
    component: () => import('@/components/glyunVue2/index.vue'),
    meta: {
      title: 'v2_plant_details_plant_screen'
    }
  },
  {
    path: "/smartQuery",
    name: "smartQuery",
    component: () => import('../views/nav/index.vue'),
    children: [
      {//数据查询-逆变器
        name: 'dataQuery/inverter',
        path: 'dataQuery/inverter',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_device_inverter',
          routeAuthCode: 'A100100',
        },
      },
      {//数据字典
        name: 'dataDictionary',
        path: 'dataDictionary',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_data_dictionary',
          routeAuthCode: 'A1002',
        },
      },
      {//逆变器仪表盘
        name: 'instrumentPanel',
        path: 'instrumentPanel',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_inverter_dashboard',
          routeAuthCode: 'A1000',
        },
      },
      {//仪表盘详情
        name: 'instrumentPanelDetail',
        path: 'instrumentPanelDetail/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_datalogger_dashboard_details'
        },
      }, {//采集器仪表盘
        name: 'collectorInstrumentPanel',
        path: 'collectorInstrumentPanel',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_datalogger_dashboard',
          routeAuthCode: 'A1003',
        },
      }, {//采集器仪表盘详情
        name: 'collectorInstrumentPanelDetail',
        path: 'collectorInstrumentPanelDetail/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: 'v2_datalogger_dashboard_details'
        },
      }, {//采集器仪表盘详情异常数据
        name: 'collectorAbnormalData',
        path: 'collectorAbnormalData',
        component: () => import('@/components/glyunVue2/index.vue'),
      },
    ]
  },
  {
    path: "/ota",
    name: "ota",
    component: () => import('../views/nav/index.vue'),
    children: [

      {//固件管理逆变器
        name: 'dataBoard',
        path: 'dataBoard',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_device_abnormal_warning_data_board",
          routeAuthCode: 'A1103',
        }
      },
      {//固件管理逆变器
        name: 'firmwareManagement/inverter',
        path: 'firmwareManagement/inverter',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_device_inverter",
          routeAuthCode: 'A1100',
        }
      },
      {//固件管理采集器
        name: 'firmwareManagement/collector',
        path: 'firmwareManagement/collector',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_device_datalogger",
          routeAuthCode: 'A1100',
        },
      },
      {//固件管理采集器 问题版本管理页面
        name: 'firmwareManagement/collector/problemColletorVersion',
        path: 'firmwareManagement/collector/problemColletorVersion',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_firmware_management_problem_version_number_management"
        },
      },
      {//固件管理采集器-固件上架记录
        name: 'firmwareManagement/:deviceType/firmwareLaunchHistory',
        path: 'firmwareManagement/:deviceType/firmwareLaunchHistory',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_firmware_shelf_records"
        }
      },
      {//固件管理EPM
        name: 'firmwareManagement/epm',
        path: 'firmwareManagement/epm',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "EPM",
          routeAuthCode: 'A1100',
        }
      }, {//固件管理BMS
        name: 'firmwareManagement/bms',
        path: 'firmwareManagement/bms',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "BMS"
        }
      },
      {//固件管理充电桩
        name: 'firmwareManagement/charger',
        path: 'firmwareManagement/charger',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_charger_charger",
          routeAuthCode: 'A1100',
        },
      },
      {//固件管理大包升级
        name: 'firmwareManagement/bigPackage',
        path: 'firmwareManagement/bigPackage',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_ota_aggregated_upgrade",
          routeAuthCode: 'A1100',
        },
      },
      {//固件管理电池
        name: 'firmwareManagement/battery',
        path: 'firmwareManagement/battery',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_plant_details_battery",
          routeAuthCode: 'A1100',
        },
      },
      {// 固件详情
        name: 'firmwareManagement/details/:id',
        path: 'firmwareManagement/details/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_firmware_info_firmware_info"
        }
      }, {// 升级记录
        name: 'firmwareManagement/firmwareUpgradeRecord/:id',
        path: 'firmwareManagement/firmwareUpgradeRecord/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_datalogger_details_upgrade_record"
        }
      }, {// 验证记录
        name: 'firmwareManagement/verifyRecords/:id',
        path: 'firmwareManagement/verifyRecords/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_ota_verification_record"
        }
      },
      // 任务管理模块
      {//任务管理逆变器
        name: 'taskManagement/inverter',
        path: 'taskManagement/inverter',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_device_inverter",
          routeAuthCode: 'A1101',
        }
      },
      {//任务管理采集器
        name: 'taskManagement/collector',
        path: 'taskManagement/collector',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_device_datalogger",
          routeAuthCode: 'A1101',
        }
      }, {//任务管理EPM
        name: 'taskManagement/epm',
        path: 'taskManagement/epm',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "EPM",
          routeAuthCode: 'A1101',
        }
      }, {//任务管理BMS
        name: 'taskManagement/bms',
        path: 'taskManagement/bms',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "BMS"
        }
      },
      {//任务管理充电桩
        name: 'taskManagement/charger',
        path: 'taskManagement/charger',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_charger_charger",
        }
      },
      {//任务管理大包升级
        name: 'taskManagement/bigPackage',
        path: 'taskManagement/bigPackage',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_ota_aggregated_upgrade",
        }
      },
       {//任务管理电池
        name: 'taskManagement/battery',
        path: 'taskManagement/battery',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_plant_details_battery",
        }
      },
      {// 任务详情
        name: 'taskManagement/details/:id',
        path: 'taskManagement/details/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_ota_task_info"
        }
      }, {// 升级记录
        name: 'taskManagement/taskUpgradeRecord/:id',
        path: 'taskManagement/taskUpgradeRecord/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_datalogger_details_upgrade_record",
        }
      },

      {//设备升级记录
        name: 'upgradeRecord/universalRecordPage/:deviceType',
        path: 'upgradeRecord/universalRecordPage/:deviceType',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_export_record_device_upgrade_record",
          routeAuthCode: 'A1102',
        }
      }, {//设备升级记录
        name: 'upgradeRecord/deviceUpgrade/:id',
        path: 'upgradeRecord/deviceUpgrade/:id',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_task_management_ota_upgrade"
        }
      },

      {// 数据分析
        name: 'dataAnalysis',
        path: 'dataAnalysis',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_firmware_management_analyse_data"
        }
      },
      {// 用户升级申请逆变器
        name: 'userUpgradeRequest/inverter',
        path: 'userUpgradeRequest/inverter',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_task_management_ota_upgrade",
          routeAuthCode: 'A1104',
        }
      },
      {// 用户升级申请采集器
        name: 'userUpgradeRequest/collector',
        path: 'userUpgradeRequest/collector',
        component: () => import('@/components/glyunVue2/index.vue'),
        meta: {
          title: "v2_task_management_ota_upgrade",
          routeAuthCode: 'A1104',
        }
      },
    ]
  },

  //下面是H5页面
  {
    path: "/instructionManual",
    // name: "说明书",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/newbieGuide",
    // name: "新手引导",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/installationVideo",
    // name: "安装视频",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/guideRegistration",
    // name: "注册引导",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  //质保查询
  {
    path: "/queryWarrantyH5",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  //质保查询
  {
    path: "/serviceCenterH5",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  // 澳洲逆变器升级
  {
    path: "/AuManualUpgrade",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  //上面是H5页面
  {
    path: "/demo",
    name: "demo",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/demo2",
    name: "demo2",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/demo3",
    name: "demo3",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/operationDetails",
    name: "operationDetails",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {// 三方回调页面 flatpeak结果页
    path: "/threeParties/flatpeak",
    name: "threePartiesFlatpeak",
    // component: resolve => require(['../views/threeParties/flatpeak.vue'], resolve)
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/500",
    name: "notConnect",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/404",
    name: "notFound",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/403",
    name: "notPermission",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/a/:id",
    name: "alarmdetailH5",
    component: () => import('@/components/glyunVue2/index.vue'),
  },
  {
    path: "/:pathMatch(.*)*", // 此处需特别注意置于最底部
    redirect: "/404"
  },
]
